import { deleteRequest, getRequest, postRequest } from '../../helpers/request'

export const TYPES = {
  API_REQUEST: 'API_REQUEST',
  API_ERROR: 'API_ERROR',
  API_SUCCESS: 'API_SUCCESS',
  CLEAR_ALERT: 'CLEAR_ALERT',
  SET_ALERT: 'SET_ALERT',

  CREATE_TEMPLATE_SUCCESS: 'CREATE_TEMPLATE_SUCCESS',
  LIST_TEMPLATE_SUCCESS: 'LIST_TEMPLATE_SUCCESS',
  DELETE_TEMPLATE_SUCCESS: 'DELETE_TEMPLATE_SUCCESS',
  UPDATE_TEMPLATE_SUCCESS: 'UPDATE_TEMPLATE_SUCCESS',
  SHARE_TEMPLATE_SUCCESS: 'SHARE_TEMPLATE_SUCCESS'
}

export const clearAlert = () => async dispatch => {
  dispatch({ type: TYPES.CLEAR_ALERT })
}

export const setAlert = (error, msg) => async dispatch => {
  dispatch({ type: TYPES.SET_ALERT, data: { error, msg } })
}

export const createTemplate = (formData) => async dispatch => {
  dispatch({ type: TYPES.API_REQUEST })
  try {
    // console.log({ "name2": name, "uploadedJSName2": uploadedJSName, "uploadedJSFile2": uploadedJSFile })
    const { data } = await postRequest(
      `templates`,
      formData,
      {
        headers: {
          'x-access-token': localStorage.getItem('token'),
          'x-refresh-token': localStorage.getItem('refreshToken'),
          changeOrigin: true
        }
      }
    )

    if (data.isSuccess) {
      console.log(data.template);
      dispatch({
        type: TYPES.CREATE_TEMPLATE_SUCCESS,
        payload: data.template
      })
    } else {
      dispatch({
        type: TYPES.API_ERROR,
        msg: data.msg
      })
    }
  } catch (err) {
    console.log(err)
    dispatch({
      type: TYPES.API_ERROR,
      msg: JSON.stringify(err)
    })
  }
}

export const cloneTemplate = (name, tId) => async dispatch => {
  dispatch({ type: TYPES.API_REQUEST })
  try {
    const { data } = await postRequest(
      `templates/${tId}`,
      { name },
      {
        headers: {
          'x-access-token': localStorage.getItem('token'),
          'x-refresh-token': localStorage.getItem('refreshToken'),
          changeOrigin: true
        }
      }
    )

    if (data.isSuccess) {
      dispatch({
        type: TYPES.CREATE_TEMPLATE_SUCCESS,
        payload: data.template
      })
    } else {
      dispatch({
        type: TYPES.API_ERROR,
        msg: data.msg
      })
    }
  } catch (err) {
    console.log(err)
    dispatch({
      type: TYPES.API_ERROR,
      msg: JSON.stringify(err)
    })
  }
}

export const updateTemplate = (name, tId) => async dispatch => {
  dispatch({ type: TYPES.API_REQUEST })
  try {
    const { data } = await postRequest(
      `templates/${tId}/update`,
      { name: name },
      {
        headers: {
          'x-access-token': localStorage.getItem('token'),
          'x-refresh-token': localStorage.getItem('refreshToken'),
          changeOrigin: true
        }
      }
    )
    if (data.isSuccess) {
      dispatch({
        type: TYPES.UPDATE_TEMPLATE_SUCCESS,
        data: { name, tId }
      })
      window.location.reload();
    } else {
      dispatch({ type: TYPES.API_ERROR, msg: data.msg })
    }
  } catch (error) {
    console.log(error)
    dispatch({ type: TYPES.API_ERROR, msg: JSON.stringify(error) })
  }
}

export const listTemplates = (initialDate, finalDate) => async dispatch => {
  dispatch({ type: TYPES.API_REQUEST })
  try {
    const queryParams = `?startDate=${initialDate}&endDate=${finalDate}`;
    const { data } = await getRequest(`templates/list-user-templates${queryParams}`, {
      headers: {
        'x-access-token': localStorage.getItem('token'),
        'x-refresh-token': localStorage.getItem('refreshToken'),
        changeOrigin: true
      }
    })

    if (data.isSuccess) {
      dispatch({
        type: TYPES.LIST_TEMPLATE_SUCCESS,
        payload: data.templates
      })
    } else {
      dispatch({
        type: TYPES.API_ERROR,
        msg: data.msg
      })
    }
  } catch (err) {
    console.log(err)
    dispatch({
      type: TYPES.API_ERROR,
      msg: JSON.stringify(err)
    })
  }
}

export const deleteTemplate = templateId => async dispatch => {
  try {
    const { data } = await deleteRequest(`templates/${templateId}`)
    if (data.isSuccess) {
      dispatch({
        type: TYPES.DELETE_TEMPLATE_SUCCESS,
        payload: templateId
      })
    } else {
      dispatch({
        type: TYPES.API_ERROR,
        msg: data.msg
      })
    }
  } catch (err) {
    console.log(err)
    dispatch({
      type: TYPES.API_ERROR,
      msg: JSON.stringify(err)
    })
  }
}

export const shareTemplate = (tId, uId) => async dispatch => {
  dispatch({ type: TYPES.API_REQUEST })
  try {
    const { data } = await postRequest(
      `templates/${tId}/share`,
      { userId: uId },
      {
        headers: {
          'x-access-token': localStorage.getItem('token'),
          'x-refresh-token': localStorage.getItem('refreshToken'),
          changeOrigin: true
        }
      }
    )
    if (data.isSuccess) {
      dispatch({
        type: TYPES.SHARE_TEMPLATE_SUCCESS,
        data: { tId, sharedWithData: data.sharedWithData }
      })
    } else {
      dispatch({ type: TYPES.API_ERROR, msg: data.msg })
    }
  } catch (error) {
    console.log(error)
    dispatch({
      type: TYPES.API_ERROR,
      msg: JSON.stringify(error)
    })
  }
}

export const syncTemplate = tId => async dispatch => {
  dispatch({ type: TYPES.API_REQUEST })
  try {
    const { data } = await postRequest(`templates/${tId}/sync-temp-to-km`)

    if (data.isSuccess) {
      alert('Sync successful!!')
      dispatch({ type: TYPES.API_SUCCESS })
    } else {
      const alertMsg =
        data.msg || 'Sync unsuccessful!\nPlease try again after some time'
      alert(alertMsg)
      dispatch({
        type: TYPES.API_ERROR,
        payload: data.msg
      })
    }
  } catch (err) {
    alert('Sync unsuccessful!\nPlease try again after some time')
    console.log(err)
    dispatch({
      type: TYPES.API_ERROR,
      payload: JSON.stringify(err)
    })
  }
}

export const updateTemplateThumbAction = (formData, tId) => async dispatch => {
  dispatch({ type: TYPES.API_REQUEST })
  try {
    const { data } = await postRequest(
      `templates/${tId}/thumb`,
      formData,
      {
        headers: {
          'x-access-token': localStorage.getItem('token'),
          'x-refresh-token': localStorage.getItem('refreshToken'),
          changeOrigin: true,
          "Content-Type": "multipart/form-data",
        }
      }
    )
    if (data.isSuccess) {
      dispatch({
        type: TYPES.API_SUCCESS,
        msg: data.msg
      });
      window.location.reload();
    } else {
      dispatch({ type: TYPES.API_ERROR, msg: data.msg })
    }
  } catch (error) {
    console.log(error)
    dispatch({ type: TYPES.API_ERROR, msg: JSON.stringify(error) })
  }
}